import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AssetsStore, StudentStore, UserDetails, UserStore, ViewStore } from '@coach-bot/data-access/shared';
import { faArrowUpRightFromSquare, faWallet } from '@fortawesome/free-solid-svg-icons';
import { AbstractComponent } from '@shared/ui';
import { formatMoneyString } from '@shared/utils';
import { BehaviorSubject, Observable, combineLatest, map, takeUntil } from 'rxjs';

@Component({
  selector: 'st-profile',
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent extends AbstractComponent implements OnInit {
  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;
  readonly currencySign$: BehaviorSubject<string> = this.viewStore.currencySign$;
  readonly studentBalance$: BehaviorSubject<number> = this.studentStore.studentBalance$;
  readonly userDetails$: BehaviorSubject<UserDetails> = this.userStore.userDetails$;

  readonly userAvatar$: Observable<string> = combineLatest([this.assetsPath$, this.userDetails$]).pipe(
    map(
      ([assetsPath, userDetails]: [string, UserDetails | undefined]) =>
        userDetails?.profileImageURL || `${assetsPath}/images/default-avatar.jpeg`
    )
  );

  readonly studentBalanceString$: Observable<string> = this.studentBalance$.pipe(
    takeUntil(this.destroyed$),
    map((studentBalance: number) => {
      return formatMoneyString(studentBalance);
    })
  );

  readonly icons = {
    faArrowUpRightFromSquare,
    faWallet,
  };

  constructor(
    private assetsStore: AssetsStore,
    private changeDetectorRef: ChangeDetectorRef,
    private studentStore: StudentStore,
    private userStore: UserStore,
    private viewStore: ViewStore
  ) {
    super();
  }

  ngOnInit(): void {
    combineLatest([this.studentBalance$, this.userDetails$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.changeDetectorRef.detectChanges();
      });
  }
}
